module.exports = __webpack_public_path__ + "static/media/logo.f9d381c5.svg";